import { render, staticRenderFns } from "./paycools-index.vue?vue&type=template&id=128a4e09&scoped=true"
import script from "./paycools-index.vue?vue&type=script&lang=js"
export * from "./paycools-index.vue?vue&type=script&lang=js"
import style0 from "./paycools-index.vue?vue&type=style&index=0&id=128a4e09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128a4e09",
  null
  
)

export default component.exports